/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject8
     */
    aktid: number;
    /**
     * 
     * @type {number}
     * @memberof InlineObject8
     */
    statusid: number;
}

export function InlineObject8FromJSON(json: any): InlineObject8 {
    return InlineObject8FromJSONTyped(json, false);
}

export function InlineObject8FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject8 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aktid': json['aktid'],
        'statusid': json['statusid'],
    };
}

export function InlineObject8ToJSON(value?: InlineObject8 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aktid': value.aktid,
        'statusid': value.statusid,
    };
}


